import React from "react"
import { Box, List } from "@mui/material"
import {
  HiOutlineSpeakerphone,
  HiSpeakerphone,
  HiUserGroup,
  HiOutlineUserGroup,
  HiOutlineStar,
  HiPaperAirplane,
  HiOutlinePaperAirplane,
  HiCloudDownload,
  HiOutlineCloudDownload,
  HiDatabase,
  HiOutlineDatabase,
  HiOutlineFolderOpen,
  HiFolderOpen,
} from "react-icons/hi"

import SidebarItem from "components/SidebarItem"
import SecondarySidebarBase from "components/sidebars/SecondarySidebarBase"
import SidebarDivider from "components/sidebars/SidebarDivider"

export default function SecondarySidebarInternal() {
  return (
    <SecondarySidebarBase>
      <Box
        sx={{
          pt: 1.5,
          px: 2.5,
          fontSize: "sm",
          fontWeight: 600,
          color: "gray.700",
        }}
        my={1}
        display="flex"
        alignItems="center"
        gap={1}
      >
        Internal Tools
      </Box>
      <List sx={{ pt: 0.5, pb: 0 }}>
        <SidebarItem
          title="Operations"
          href={{
            pathname: `/dashboard/internal/ops/details`,
          }}
          icon={<HiUserGroup />}
          outlineIcon={<HiOutlineUserGroup />}
          activePaths={[
            {
              path: "/dashboard/internal/ops",
              strategy: "startsWith",
            },
          ]}
        />
        <SidebarItem
          title="Verticals"
          href={{
            pathname: `/dashboard/internal/verticals`,
          }}
          icon={<HiFolderOpen />}
          outlineIcon={<HiOutlineFolderOpen />}
        />
        <SidebarItem
          title="Demos"
          href={{
            pathname: `/dashboard/internal/demos`,
          }}
          icon={<HiPaperAirplane />}
          outlineIcon={<HiOutlinePaperAirplane />}
        />
        <SidebarItem
          title="High Priority"
          href={{
            pathname: `/dashboard/internal/highPriorityCompanies`,
          }}
          icon={<HiDatabase />}
          outlineIcon={<HiOutlineDatabase />}
        />
        <SidebarDivider />
        <SidebarItem
          title="Marketing"
          href={{
            pathname: `/dashboard/internal/marketing`,
          }}
          icon={<HiSpeakerphone />}
          outlineIcon={<HiOutlineSpeakerphone />}
        />
        <SidebarItem
          title="API Monitoring"
          href={{
            pathname: `/dashboard/internal/api`,
          }}
          icon={<HiCloudDownload />}
          outlineIcon={<HiOutlineCloudDownload />}
        />
        <Box
          onClick={() => {
            // @ts-ignore
            window.location = "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
          }}
        >
          <SidebarItem
            href={{
              pathname: "",
            }}
            activePaths={[]}
            title="Get a Raise"
            outlineIcon={<HiOutlineStar />}
          />
        </Box>
      </List>
    </SecondarySidebarBase>
  )
}
